<template>
  <span class="d-flex gap-2 flex-wrap">
    <b-badge v-if="showBm" class="approval-step-badge">ผู้จัดการคลัง</b-badge>
    <b-badge v-if="showHq" class="approval-step-badge">สำนักงานใหญ่</b-badge>
  </span>
</template>

<script>
export default {
  name: "ApprovalSteps",
  props: {
    showBm: {
      type: Boolean,
      default: true,
    },
    showHq: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.approval-step-badge {
  font-size: 14px;
  font-weight: 400;
  padding: 0.35em 0.65em;
  border-radius: 20px;
  background-color: transparent !important;
  color: #3e495b !important;
  border: 1px solid #c8cacf;
  white-space: nowrap;
}
</style>
